export enum AmplitudeInteractionChannel {
    WEB_MOBILE = 'web_mobile',
    WEB_DESKTOP = 'web_desktop',
  }
